import React, { useState, useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import axios from 'axios';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Link } from 'react-router-dom';
import { API_KEY, API_ENDPOINTS, LANGUAGE, IMAGE_BASE_URL } from '../config/api';
import './MainPage.css';


const MainPage = () => {
    const [activeCategory, setActiveCategory] = useState('movies');
    const [nowPlayMovie, setNowPlayMovie] = useState([]);
    const [popularMovies, setPopularMovies] = useState([]);
    const [topMovies, setTopMovies] = useState([]);
    const [popularTV, setPopularTV] = useState([]);
    const [topTV, setTopTV] = useState([]);
    const [airingTV, setAiringTV] = useState([]);
    const [animatedMovies, setAnimatedMovies] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchMovies = async () => {
            try {
                setLoading(true);
                const [nowPlaying, popular, topRated] = await Promise.all([
                    axios.get(`${API_ENDPOINTS.NOW_PLAYING}?api_key=${API_KEY}&language=${LANGUAGE}`),
                    axios.get(`${API_ENDPOINTS.POPULAR}?api_key=${API_KEY}&language=${LANGUAGE}`),
                    axios.get(`${API_ENDPOINTS.TOP_RATED}?api_key=${API_KEY}&language=${LANGUAGE}`)
                ]);
                setNowPlayMovie(nowPlaying.data.results);
                setPopularMovies(popular.data.results);
                setTopMovies(topRated.data.results);
            } catch (error) {
                console.error('Error fetching movies:', error);
            } finally {
                setLoading(false);
            }
        };

        const fetchTV = async () => {
            try {
                setLoading(true);
                const [popular, topRated, airing] = await Promise.all([
                    axios.get(`${API_ENDPOINTS.TV_POPULAR}?api_key=${API_KEY}&language=${LANGUAGE}`),
                    axios.get(`${API_ENDPOINTS.TV_TOP_RATED}?api_key=${API_KEY}&language=${LANGUAGE}`),
                    axios.get(`${API_ENDPOINTS.TV_AIRING_TODAY}?api_key=${API_KEY}&language=${LANGUAGE}`)
                ]);
                setPopularTV(popular.data.results);
                setTopTV(topRated.data.results);
                setAiringTV(airing.data.results);
            } catch (error) {
                console.error('Error fetching TV shows:', error);
            } finally {
                setLoading(false);
            }
        };

        const fetchAnimated = async () => {
            try {
                setLoading(true);
                const response = await axios.get(`${API_ENDPOINTS.ANIMATED_MOVIES}&api_key=${API_KEY}&language=${LANGUAGE}&sort_by=popularity.desc`);
                setAnimatedMovies(response.data.results);
            } catch (error) {
                console.error('Error fetching animated movies:', error);
            } finally {
                setLoading(false);
            }
        };

        if (activeCategory === 'movies') {
            fetchMovies();
        } else if (activeCategory === 'tv') {
            fetchTV();
        } else if (activeCategory === 'animated') {
            fetchAnimated();
        }
    }, [activeCategory])

    const settings = {
        dots: true,
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 2,
        autoplay: false,
        speed: 500,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            }
        ]
    };

    if (loading) {
        return (
            <div className="main-page">
                <Header />
                <div className="loading-container">
                    <div className="spinner"></div>
                    <p>Загрузка фильмов...</p>
                </div>
                <Footer />
            </div>
        );
    }

    return (
        <div className="main-page">
            <Header />
            <div className={'container-xl mt-5'}>
                <div className="category-tabs">
                    <button 
                        className={`category-tab ${activeCategory === 'movies' ? 'active' : ''}`}
                        onClick={() => setActiveCategory('movies')}
                    >
                        🎬 Фильмы
                    </button>
                    <button 
                        className={`category-tab ${activeCategory === 'tv' ? 'active' : ''}`}
                        onClick={() => setActiveCategory('tv')}
                    >
                        📺 Сериалы
                    </button>
                    <button 
                        className={`category-tab ${activeCategory === 'animated' ? 'active' : ''}`}
                        onClick={() => setActiveCategory('animated')}
                    >
                        🎨 Мультфильмы
                    </button>
                </div>

                {activeCategory === 'movies' && (
                    <>
                        <section className="movie-section">
                    <h2 className="section-title">
                        <span className="title-icon">🎬</span>
                        Сейчас в кинотеатрах
                    </h2>
                    <Slider {...settings}>
                        {nowPlayMovie.map(movie => (
                            <div key={movie.id} className="movie-slide">
                                <Link to={`/film/id/${movie.id}`} className="movie-card-link">
                                    <div className="movie-card-container">
                                        <img
                                            className={'movie-poster'}
                                            src={movie.poster_path ? `${IMAGE_BASE_URL}/w342${movie.poster_path}` : '/images/placeholder.jpg'}
                                            alt={movie.title}
                                        />
                                        <div className="movie-overlay">
                                            <div className="movie-rating">
                                                <span>⭐ {movie.vote_average?.toFixed(1)}</span>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </Slider>
                </section>

                <section className="movie-section">
                    <h2 className="section-title">
                        <span className="title-icon">🔥</span>
                        Популярные фильмы
                    </h2>
                    <Slider {...settings}>
                        {popularMovies.map(movie => (
                            <div key={movie.id} className="movie-slide">
                                <Link to={`/film/id/${movie.id}`} className="movie-card-link">
                                    <div className="movie-card-container">
                                        <img
                                            className={'movie-poster'}
                                            src={movie.poster_path ? `${IMAGE_BASE_URL}/w342${movie.poster_path}` : '/images/placeholder.jpg'}
                                            alt={movie.title}
                                        />
                                        <div className="movie-overlay">
                                            <div className="movie-rating">
                                                <span>⭐ {movie.vote_average?.toFixed(1)}</span>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </Slider>
                </section>

                <section className="movie-section">
                    <h2 className="section-title">
                        <span className="title-icon">⭐</span>
                        Топ фильмы
                    </h2>
                    <Slider {...settings}>
                        {topMovies.map(movie => (
                            <div key={movie.id} className="movie-slide">
                                <Link to={`/film/id/${movie.id}`} className="movie-card-link">
                                    <div className="movie-card-container">
                                        <img
                                            className={'movie-poster'}
                                            src={movie.poster_path ? `${IMAGE_BASE_URL}/w342${movie.poster_path}` : '/images/placeholder.jpg'}
                                            alt={movie.title}
                                        />
                                        <div className="movie-overlay">
                                            <div className="movie-rating">
                                                <span>⭐ {movie.vote_average?.toFixed(1)}</span>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </Slider>
                </section>
                    </>
                )}

                {activeCategory === 'tv' && (
                    <>
                        <section className="movie-section">
                            <h2 className="section-title">
                                <span className="title-icon">📺</span>
                                Популярные сериалы
                            </h2>
                            <Slider {...settings}>
                                {popularTV.map(tv => (
                                    <div key={tv.id} className="movie-slide">
                                        <Link to={`/tv/id/${tv.id}`} className="movie-card-link">
                                            <div className="movie-card-container">
                                                <img
                                                    className={'movie-poster'}
                                                    src={tv.poster_path ? `${IMAGE_BASE_URL}/w342${tv.poster_path}` : '/images/placeholder.jpg'}
                                                    alt={tv.name}
                                                />
                                                <div className="movie-overlay">
                                                    <div className="movie-rating">
                                                        <span>⭐ {tv.vote_average?.toFixed(1)}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                ))}
                            </Slider>
                        </section>

                        <section className="movie-section">
                            <h2 className="section-title">
                                <span className="title-icon">⭐</span>
                                Топ сериалы
                            </h2>
                            <Slider {...settings}>
                                {topTV.map(tv => (
                                    <div key={tv.id} className="movie-slide">
                                        <Link to={`/tv/id/${tv.id}`} className="movie-card-link">
                                            <div className="movie-card-container">
                                                <img
                                                    className={'movie-poster'}
                                                    src={tv.poster_path ? `${IMAGE_BASE_URL}/w342${tv.poster_path}` : '/images/placeholder.jpg'}
                                                    alt={tv.name}
                                                />
                                                <div className="movie-overlay">
                                                    <div className="movie-rating">
                                                        <span>⭐ {tv.vote_average?.toFixed(1)}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                ))}
                            </Slider>
                        </section>

                        <section className="movie-section">
                            <h2 className="section-title">
                                <span className="title-icon">📡</span>
                                Сегодня в эфире
                            </h2>
                            <Slider {...settings}>
                                {airingTV.map(tv => (
                                    <div key={tv.id} className="movie-slide">
                                        <Link to={`/tv/id/${tv.id}`} className="movie-card-link">
                                            <div className="movie-card-container">
                                                <img
                                                    className={'movie-poster'}
                                                    src={tv.poster_path ? `${IMAGE_BASE_URL}/w342${tv.poster_path}` : '/images/placeholder.jpg'}
                                                    alt={tv.name}
                                                />
                                                <div className="movie-overlay">
                                                    <div className="movie-rating">
                                                        <span>⭐ {tv.vote_average?.toFixed(1)}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                ))}
                            </Slider>
                        </section>
                    </>
                )}

                {activeCategory === 'animated' && (
                    <section className="movie-section">
                        <h2 className="section-title">
                            <span className="title-icon">🎨</span>
                            Популярные мультфильмы
                        </h2>
                        <Slider {...settings}>
                            {animatedMovies.map(movie => (
                                <div key={movie.id} className="movie-slide">
                                    <Link to={`/film/id/${movie.id}`} className="movie-card-link">
                                        <div className="movie-card-container">
                                            <img
                                                className={'movie-poster'}
                                                src={movie.poster_path ? `${IMAGE_BASE_URL}/w342${movie.poster_path}` : '/images/placeholder.jpg'}
                                                alt={movie.title}
                                            />
                                            <div className="movie-overlay">
                                                <div className="movie-rating">
                                                    <span>⭐ {movie.vote_average?.toFixed(1)}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            ))}
                        </Slider>
                    </section>
                )}
            </div>
            <Footer />
        </div>
    );
};

export default MainPage;
